<template>
  <div id="app">
    <v-app>
      <!-- ✅ BARRA SUPERIOR CORRIGIDA -->
      <v-app-bar 
        app 
        fixed
        clipped-left 
        elevation="4" 
        class="app-bar-gradient" 
        height="64"
        style="position: fixed !important; top: 0 !important; z-index: 2000 !important;"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="nav-icon">
          <v-icon>mdi-menu</v-icon>
        </v-app-bar-nav-icon>

        <!-- Logo e Título -->
        <div class="d-flex align-center logo-clickable" @click="goToHome" style="cursor: pointer;">
          <v-avatar size="40" class="mr-3 logo-avatar">
            <v-icon color="white" size="24">mdi-factory</v-icon>
          </v-avatar>
          <div>
            <v-toolbar-title class="app-title">JODARC</v-toolbar-title>
            <div class="app-subtitle">Sistema de Produção</div>
          </div>
        </div>

        <v-spacer></v-spacer>

        <!-- Busca Rápida (estilo Tabosa2028) -->
        <v-btn
          variant="flat"
          size="small"
          rounded="pill"
          color="white"
          class="mr-2 d-none d-sm-flex text-none font-weight-black px-4 elevation-1 topbar-search-btn"
          @click="abrirBuscaRapida"
        >
          <v-icon icon="mdi-magnify" size="18" class="mr-2 topbar-search-icon" />
          <span>Pesquisar</span>
          <v-chip
            density="compact"
            size="x-small"
            variant="flat"
            color="blue-darken-2"
            class="ml-3 font-weight-black"
          >
            CTRL+K
          </v-chip>
        </v-btn>

        <v-divider vertical class="mx-2 toolbar-divider"></v-divider>

        <!-- Menu do Usuário -->
        <v-menu v-model="userMenuVisible" :close-on-content-click="false" location="bottom end" origin="top right"
          transition="slide-y-transition" :offset="8">
          <template #activator="{ props }">
            <v-btn v-bind="props" class="user-menu-btn" variant="text" rounded="lg">
              <v-avatar size="36" class="user-avatar">
                <v-icon color="white">mdi-account</v-icon>
              </v-avatar>
              <div class="ml-2 d-none d-md-block text-left">
                <div class="user-name">{{ nomeUsuario }}</div>
                <div class="user-role">{{ usuarioAdmin }}</div>
              </div>
              <v-icon class="ml-2">mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-card class="user-menu-card" min-width="320" elevation="12">
            <!-- Header do Menu -->
            <v-card-title class="user-menu-header pa-4">
              <v-avatar size="48" class="mr-3">
                <v-icon color="white" size="28">mdi-account</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 text-white font-weight-bold">{{ nomeUsuario }}</div>
                <div class="text-body-2 text-white opacity-90">{{ cargoUsuario }}</div>
                <v-chip :color="usuarioAdmin === 'Administrador' ? 'warning' : 'info'" size="x-small" class="mt-1">
                  {{ usuarioAdmin }}
                </v-chip>
              </div>
            </v-card-title>

            <v-divider></v-divider>

            <!-- Itens do Menu -->
            <v-list class="pa-2">
              <!-- Changelog -->
              <v-list-item class="menu-list-item" rounded="lg" @click="showChangelogModal = true">
                <template v-slot:prepend>
                  <v-avatar size="32" color="info" variant="tonal">
                    <v-icon size="18">mdi-history</v-icon>
                  </v-avatar>
                </template>
                <v-list-item-title class="font-weight-medium">Novidades</v-list-item-title>
                <v-list-item-subtitle>Histórico de versões</v-list-item-subtitle>
                <template v-slot:append>
                  <v-chip color="error" size="x-small" v-if="hasNewUpdates">
                    Novo
                  </v-chip>
                </template>
              </v-list-item>

              <!-- Editor do Changelog (Admin) -->
              <v-list-item v-if="isAuthorizedUser" class="menu-list-item" rounded="lg"
                @click="showChangelogEditor = true">
                <template v-slot:prepend>
                  <v-avatar size="32" color="warning" variant="tonal">
                    <v-icon size="18">mdi-pencil</v-icon>
                  </v-avatar>
                </template>
                <v-list-item-title class="font-weight-medium">Editar Changelog</v-list-item-title>
                <v-list-item-subtitle>Gerenciar versões</v-list-item-subtitle>
              </v-list-item>

              <v-divider class="my-2"></v-divider>

              <!-- Logout -->
              <v-list-item class="menu-list-item logout-item" rounded="lg" @click="logout">
                <template v-slot:prepend>
                  <v-avatar size="32" color="error" variant="tonal">
                    <v-icon size="18">mdi-logout</v-icon>
                  </v-avatar>
                </template>
                <v-list-item-title class="font-weight-medium text-error">Sair</v-list-item-title>
                <v-list-item-subtitle>Encerrar sessão</v-list-item-subtitle>
              </v-list-item>
            </v-list>

            <!-- Footer do Menu -->
            <v-divider></v-divider>
            <div class="pa-3 text-center">
              <div class="text-caption text-grey">
                <v-icon size="12" class="mr-1">mdi-information</v-icon>
                Versão {{ APP_VERSION }} • {{ APP_DATE }}
              </div>
              <div class="text-caption text-grey mt-1">
                Desenvolvido por Tabosa Sistemas
              </div>
            </div>
          </v-card>
        </v-menu>
      </v-app-bar>

      <!-- ✅ MENU LATERAL CORRIGIDO -->
      <v-navigation-drawer 
        v-model="drawer" 
        app 
        fixed
        clipped-left 
        width="420" 
        variant="persistent" 
        class="navigation-drawer"
        elevation="8"
        style="position: fixed !important; z-index: 1500 !important;"
      >
        <!-- ✅ HEADER COM CONTROLES AVANÇADOS -->
        <div class="drawer-header-advanced">
          <div class="d-flex align-center pa-4">
            <v-avatar size="40" color="primary" class="mr-3">
              <v-icon color="white">mdi-view-dashboard</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-h6 font-weight-bold">Menu Principal</div>
              <div class="text-caption text-grey">{{ totalItensVisiveis }} de {{ totalItens }} módulos</div>
            </div>

            <v-spacer></v-spacer>

            <v-btn icon size="small" variant="text" @click="toggleAllSections" :color="allExpanded ? 'primary' : 'grey'"
              class="control-btn">
              <v-icon size="16">{{ allExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- ✅ CONTAINER PRINCIPAL COM ALTURA DINÂMICA -->
        <div class="menu-main-container" :class="{
          'with-history': historyEnabled,
          'compact-mode': !historyEnabled
        }">

          <!-- Lista com Submenus -->
          <div class="menu-content-scrollable">
            <v-list class="pa-2">
              <!-- ✅ SEÇÃO: EXPEDIENTE & RH -->
              <div class="menu-section" v-if="filteredMenuExpediente.length > 0">
                <div class="section-header pa-3" @click="toggleSection('expediente')">
                  <v-icon color="indigo-darken-2" class="mr-2">mdi-clock</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-indigo-darken-2">EXPEDIENTE & RH</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="indigo-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuExpediente.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.expediente }" class="section-toggle-icon"
                    color="indigo-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.expediente">
                    <v-list-item v-for="item in filteredMenuExpediente" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: PRODUÇÃO -->
              <div class="menu-section" v-if="filteredMenuProducao.length > 0">
                <div class="section-header pa-3" @click="toggleSection('producao')">
                  <v-icon color="amber-darken-2" class="mr-2">mdi-factory</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-amber-darken-2">PRODUÇÃO</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="amber-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuProducao.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.producao }" class="section-toggle-icon"
                    color="amber-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.producao">
                    <v-list-item v-for="item in filteredMenuProducao" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: PLANEJAMENTO -->
              <div class="menu-section" v-if="filteredMenuPlanejamento.length > 0">
                <div class="section-header pa-3" @click="toggleSection('planejamento')">
                  <v-icon color="purple-darken-2" class="mr-2">mdi-calendar-clock</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-purple-darken-2">PLANEJAMENTO</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="purple-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuPlanejamento.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.planejamento }" class="section-toggle-icon"
                    color="purple-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.planejamento">
                    <v-list-item v-for="item in filteredMenuPlanejamento" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: MÁQUINAS & EQUIPAMENTOS -->
              <div class="menu-section" v-if="filteredMenuMaquinas.length > 0">
                <div class="section-header pa-3" @click="toggleSection('maquinas')">
                  <v-icon color="blue-darken-2" class="mr-2">mdi-cog</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-blue-darken-2">MÁQUINAS & EQUIPAMENTOS</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="blue-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuMaquinas.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.maquinas }" class="section-toggle-icon"
                    color="blue-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.maquinas">
                    <v-list-item v-for="item in filteredMenuMaquinas" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: SUPORTE & COMUNICAÇÃO -->
              <div class="menu-section" v-if="filteredMenuSuporte.length > 0">
                <div class="section-header pa-3" @click="toggleSection('suporte')">
                  <v-icon color="green-darken-2" class="mr-2">mdi-headset</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-green-darken-2">SUPORTE & COMUNICAÇÃO</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="green-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuSuporte.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.suporte }" class="section-toggle-icon"
                    color="green-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.suporte">
                    <v-list-item v-for="item in filteredMenuSuporte" :key="item.text" class="menu-item-modern mb-1 ml-4"
                      rounded="lg" @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)"
                      @mouseenter="setHoveredItem(item)" @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: RELATÓRIOS -->
              <div class="menu-section" v-if="filteredMenuRelatorios && filteredMenuRelatorios.length > 0">
                <div class="section-header pa-3" @click="toggleSection('relatorios')">
                  <v-icon color="blue-darken-2" class="mr-2">mdi-chart-box-outline</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-blue-darken-2">RELATÓRIOS</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="blue-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuRelatorios?.length || 0 }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.relatorios }" class="section-toggle-icon"
                    color="blue-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.relatorios">
                    <v-list-item v-for="item in filteredMenuRelatorios" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: SISTEMA SAPE -->
              <div class="menu-section" v-if="filteredMenuSape.length > 0">
                <div class="section-header pa-3" @click="toggleSection('sape')">
                  <v-icon color="deep-orange-darken-2" class="mr-2">mdi-server</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-deep-orange-darken-2">SISTEMA SAP</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="deep-orange-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuSape.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.sape }" class="section-toggle-icon"
                    color="deep-orange-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.sape">
                    <v-list-item v-for="item in filteredMenuSape" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="handleSapeClick(item)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: ADMINISTRAÇÃO -->
              <div class="menu-section" v-if="filteredMenuAdministracao.length > 0">
                <div class="section-header pa-3" @click="toggleSection('administracao')">
                  <v-icon color="red-darken-2" class="mr-2">mdi-shield-account</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-red-darken-2">ADMINISTRAÇÃO</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="red-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuAdministracao.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.administracao }" class="section-toggle-icon"
                    color="red-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.administracao">
                    <v-list-item v-for="item in filteredMenuAdministracao" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

              <!-- ✅ SEÇÃO: USUÁRIOS -->
              <div class="menu-section" v-if="filteredMenuUsuarios.length > 0">
                <div class="section-header pa-3" @click="toggleSection('usuarios')">
                  <v-icon color="cyan-darken-2" class="mr-2">mdi-account-group</v-icon>
                  <span class="text-subtitle-2 font-weight-bold text-cyan-darken-2">USUÁRIOS</span>
                  <v-spacer></v-spacer>
                  <v-chip size="x-small" color="cyan-darken-2" variant="tonal" class="mr-2">
                    {{ filteredMenuUsuarios.length }}
                  </v-chip>
                  <v-icon :class="{ 'rotate-180': expandedSections.usuarios }" class="section-toggle-icon"
                    color="cyan-darken-2" size="20">
                    mdi-chevron-down
                  </v-icon>
                </div>

                <v-expand-transition>
                  <div v-show="expandedSections.usuarios">
                    <v-list-item v-for="item in filteredMenuUsuarios" :key="item.text"
                      class="menu-item-modern mb-1 ml-4" rounded="lg"
                      @click="navigateTo(item.routeMobile, item.routeDesktop, item.text)" @mouseenter="setHoveredItem(item)"
                      @mouseleave="clearHoveredItem">
                      <template v-slot:prepend>
                        <v-avatar size="36" :color="item.color" variant="tonal">
                          <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
                        </v-avatar>
                      </template>

                      <div class="flex-grow-1">
                        <v-list-item-title class="font-weight-bold menu-title-complete">
                          <span v-html="highlightSearch(item.text)"></span>
                        </v-list-item-title>
                      </div>

                      <template v-slot:append>
                        <v-icon size="16" class="text-grey">mdi-chevron-right</v-icon>
                      </template>
                    </v-list-item>
                  </div>
                </v-expand-transition>
              </div>

    

            </v-list>
          </div>

          <!-- ✅ BOTÃO LOGOUT SEMPRE FIXO -->
          <div class="logout-section-minimal">
            <v-divider></v-divider>
            <div class="pa-2">
              <v-btn color="error" variant="flat" size="small" block @click="logout" class="logout-btn-minimal">
                <v-icon start size="16">mdi-logout</v-icon>
                Sair - {{ nomeUsuario }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-navigation-drawer>

      <!-- ✅ CONTEÚDO PRINCIPAL CORRIGIDO -->
      <v-main app class="main-content" style="padding-top: 64px !important;">
        <router-view></router-view>
      </v-main>

      <!-- ✅ RODAPÉ CORRIGIDO -->
      <v-footer 
        app 
        class="footer-modern"
        style="position: fixed !important; bottom: 0 !important; z-index: 1000 !important;"
      >
        <div class="d-flex align-center justify-space-between w-100 pa-2">
          <div class="d-flex align-center">
            <v-icon size="16" class="mr-2">mdi-copyright</v-icon>
            <span class="text-body-2">2025 Tabosa Sistemas</span>
          </div>

          <div class="d-flex align-center">
            <span class="text-caption text-grey">v{{ APP_VERSION }}</span>
          </div>
        </div>
      </v-footer>

      <!-- Modais -->
      <ChangelogModal :showChangelogModal="showChangelogModal"
        @update:showChangelogModal="showChangelogModal = $event" />

      <ChangelogEditor :showEditorModal="showChangelogEditor" @update:showEditorModal="showChangelogEditor = $event"
        @changelog-updated="onChangelogUpdated" />

      <!-- Busca Rápida Global -->
      <v-dialog v-model="dialogBuscaRapida" max-width="980" scrollable>
        <v-card class="busca-rapida-card">
          <v-card-title class="d-flex align-center justify-space-between py-4">
            <div class="d-flex align-center">
              <v-icon color="primary" size="30" class="mr-3">mdi-orbit-variant</v-icon>
              <div>
                <div class="text-h6 font-weight-black text-primary">BUSCA GLOBAL</div>
                <div class="text-caption text-medium-emphasis">Acesso rápido aos módulos do menu</div>
              </div>
            </div>
            <v-btn icon="mdi-close" variant="tonal" size="small" @click="fecharBuscaRapida" />
          </v-card-title>

          <v-divider />

          <v-card-text class="pt-4">
            <v-text-field
              ref="buscaRapidaInput"
              v-model="buscaRapidaTermo"
              placeholder="O que você deseja abrir?"
              prepend-inner-icon="mdi-magnify"
              variant="solo-filled"
              flat
              density="comfortable"
              clearable
              rounded="lg"
              hide-details
              class="mb-4 search-input-premium"
            >
              <template #append-inner>
                <div class="d-flex align-center ga-1 opacity-60 d-none d-sm-flex">
                  <v-chip size="x-small" variant="flat" class="font-weight-black">ESC</v-chip>
                  <span class="text-caption">para fechar</span>
                </div>
              </template>
            </v-text-field>

            <div v-if="!buscaRapidaTermo" class="text-center py-10 opacity-70">
              <v-icon size="48" color="grey-lighten-1" class="mb-3">mdi-keyboard-outline</v-icon>
              <p class="text-subtitle-1 font-weight-medium">Digite o nome da rotina para começar...</p>
              <p class="text-caption">Ex: "produtos", "transferência", "expediente"</p>
            </div>

            <div v-else-if="totalResultadosBuscaRapida === 0" class="text-center py-10">
              <v-avatar color="surface" size="80" variant="tonal" class="mb-4">
                <v-icon size="40" color="grey">mdi-magnify-remove-outline</v-icon>
              </v-avatar>
              <p class="text-h6 font-weight-bold mb-1">Nenhum resultado encontrado</p>
              <p class="text-medium-emphasis">
                Não encontramos nenhuma rotina com o termo "<strong>{{ buscaRapidaTermo }}</strong>"
              </p>
              <v-btn variant="text" color="primary" class="mt-4 font-weight-black" @click="buscaRapidaTermo = ''">
                Limpar Pesquisa
              </v-btn>
            </div>

            <div v-else class="busca-rapida-results pr-2">
              <div v-for="grupo in resultadosBuscaRapida" :key="grupo.key" class="mb-6">
                <div class="d-flex align-center mb-3">
                  <v-avatar :color="grupo.color" size="24" variant="tonal" class="mr-2">
                    <v-icon size="14">{{ grupo.icon }}</v-icon>
                  </v-avatar>
                  <span class="text-overline font-weight-black letter-spacing-2">{{ grupo.titulo }}</span>
                  <v-divider class="ml-4 border-opacity-10" />
                </div>

                <v-row dense>
                  <v-col v-for="item in grupo.itens" :key="`${grupo.key}-${item.text}`" cols="12" sm="6" lg="4">
                    <v-card
                      rounded="lg"
                      class="busca-rapida-card-item elevation-0 border mb-2"
                      @click="navegarBuscaRapida(item)"
                    >
                      <div class="d-flex align-center ga-3 pa-3">
                        <v-avatar :color="item.color || grupo.color" variant="tonal" size="42" class="rounded-lg">
                          <v-icon size="22">{{ item.icon }}</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1 overflow-hidden">
                          <div class="text-body-1 font-weight-black text-truncate" v-html="highlightBuscaRapida(item.text)" />
                          <div class="text-caption text-medium-emphasis text-truncate opacity-70">
                            {{ grupo.titulo }}
                          </div>
                        </div>
                        <v-icon size="20" class="chevron-action opacity-30">mdi-arrow-right</v-icon>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
        
      <!-- ✅ MODAL DE CARREGAMENTO DE ROTA MELHORADO -->
      <v-overlay 
        v-model="loadingRouteDialog" 
        class="route-loading-overlay"
        persistent
        opacity="0.3"
      >
        <div class="route-loading-container">
          <v-card class="route-loading-card" elevation="0">
            <v-card-text class="text-center pa-8">
              <!-- Ícone da Rota -->
              <div class="route-icon-container mb-4">
                <v-avatar size="64" color="grey-lighten-4" class="route-avatar">
                  <v-icon :color="routeIconColor" size="32">{{ routeIcon }}</v-icon>
                </v-avatar>
                
                <!-- Loading Spinner Overlay -->
                <div class="loading-spinner-overlay">
                  <v-progress-circular 
                    indeterminate 
                    color="grey-darken-2" 
                    size="72"
                    width="2"
                    class="loading-spinner"
                  ></v-progress-circular>
                </div>
              </div>
              
              <!-- Título Principal -->
              <div class="route-loading-title mb-2">
                Abrindo {{ currentRouteName }}
              </div>
              
              <!-- Subtítulo -->
              <div class="route-loading-subtitle mb-3">
                {{ loadingMessage }}
              </div>
              
              <!-- Barra de Progresso Suave -->
              <div class="progress-container">
                <v-progress-linear
                  indeterminate
                  color="grey-darken-2"
                  height="2"
                  rounded
                  class="route-progress"
                ></v-progress-linear>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-overlay>
    </v-app>
  </div>
</template>
<script>
import ChangelogModal from '@/components/ChangelogModal.vue';
import ChangelogEditor from '@/components/ChangelogEditor.vue';
import { useUserStore } from '@/store/userStore';
import { usePermissions } from '@/composables/usePermissions';

const APP_VERSION = __APP_VERSION__;
const APP_DATE = __APP_DATE__;

export default {
  components: {
    ChangelogModal,
    ChangelogEditor,
  },
  
  // Acessar a store e permissões usando setup()
  setup() {
    const userStore = useUserStore();
    const { hasAccess } = usePermissions();
    return { userStore, hasAccess };
  },

  data() {
    return {
      // Estados principais
      drawer: false,
      userMenuVisible: false,
      showChangelogModal: false,
      showChangelogEditor: false,
      hasNewUpdates: true,
      loadingRouteDialog: false,
      loadingMessage: "Preparando interface...",
      currentRouteName: "",
      routeIcon: "mdi-loading",
      routeIconColor: "grey-darken-2",

      // Controles de interface
      searchEnabled: true,
      historyEnabled: false,

      // Controles de pesquisa e expansão
      searchQuery: '',
      dialogBuscaRapida: false,
      buscaRapidaTermo: '',
      expandedSections: {
        producao: true,
        planejamento: false,
        maquinas: false,
        expediente: false,
        suporte: false,
        relatorios: false,
        sape: false,
        administracao: false,
        usuarios: false
      },

      // Variável para item em hover
      hoveredItem: null,

      // ✅ MENUS COM CONTROLE SIMPLES DE ADMIN
      menuProducao: [
        {
          text: "Lançar Produção",
          description: "Registre movimentações de produção, controle estoque e acompanhe o progresso das ordens de fabricação em tempo real.",
          icon: "mdi-factory",
          color: "amber-darken-1",
          routeMobile: "LancarProducaoDesktop",
          routeDesktop: "LancarProducaoDesktop",
          appPermission: "menu_lancar_producao",
          adminOnly: false
        },
        {
          text: "Dashboard Produção",
          description: "Visualize relatórios detalhados, métricas de performance e indicadores de produtividade da sua linha de produção.",
          icon: "mdi-chart-line",
          color: "cyan-darken-1",
          routeMobile: "DashboardProducao",
          routeDesktop: "DashboardProducao",
          appPermission: "menu_dashboard_producao",
          adminOnly: false
        },
        {
          text: "Pedidos",
          description: "Gerencie pedidos de clientes, controle prazos de entrega e acompanhe o status de cada solicitação.",
          icon: "mdi-shopping",
          color: "teal-darken-1",
          routeMobile: "ConsultaPedidosMobile",
          routeDesktop: "ConsultaPedidosMobile",
          appPermission: "menu_pedidos",
          adminOnly: false
        },
      ],



          // ✅ MENUS COM CONTROLE SIMPLES DE ADMIN
          menuPlanejamento: [
        {
          text: "Priorização de Ordens",
          description: "Priorize ordens de produção para otimizar a produção e atender prazos.",
          icon: "mdi-factory",
          color: "amber-darken-1",
          routeMobile: "PriorizacaoOrdensDesktop",
          routeDesktop: "PriorizacaoOrdensDesktop",
          appPermission: "menu_priorizacao_ordens",
          adminOnly: false
        },
        {
          text: "Planejamento Semanal",
          description: "Planeje ordens de produção semanalmente, controle de estoque e otimização de recursos.",
          icon: "mdi-calendar-blank",
          color: "blue-darken-1",
          routeMobile: "PlanejamentoSemanalDesktop",
          routeDesktop: "PlanejamentoSemanalDesktop",
          appPermission: "menu_planejamento_semanal",
          adminOnly: false
        },
        
      ],


      menuMaquinas: [
        {
          text: "Consulta de Máquinas",
          description: "Visualize informações detalhadas das máquinas, status operacional, histórico de manutenção e performance.",
          icon: "mdi-cog-outline",
          color: "blue-darken-1",
          routeMobile: "ConsultaMaquinasMobile",
          routeDesktop: "ConsultaMaquinasDesktop",
          appPermission: "menu_consulta_maquinas",
          adminOnly: false
        },
        {
          text: "Conferência de Localização",
          description: "Acesse o mapa interativo com localização das máquinas e controle de posicionamento no chão de fábrica.",
          icon: "mdi-map-marker",
          color: "green-darken-1",
          routeMobile: "ConferenciaMaquinaMapaMobile",
          routeDesktop: "ConferenciaMaquinaMapaDesktop",
          appPermission: "menu_conferencia_localizacao",
          adminOnly: false
        },
        {
          text: "Consultar Aparelhos",
          description: "Gerencie dispositivos IoT conectados, sensores e equipamentos auxiliares do sistema produtivo.",
          icon: "mdi-devices",
          color: "purple-darken-1",
          routeMobile: "consultaAparelhosMobile",
          routeDesktop: "consultaAparelhosDesktop",
          appPermission: "menu_consultar_aparelhos",
          adminOnly: false
        },
        {
          text: "Vincular Aparelho",
          description: "Conecte e configure novos aparelhos às máquinas, estabelecendo comunicação com o sistema central.",
          icon: "mdi-link-variant",
          color: "orange-darken-1",
          routeMobile: "VincularAparelhoMobile",
          routeDesktop: "VincularAparelhoDesktop",
          appPermission: "menu_vincular_aparelho",
          adminOnly: false
        },
      ],

      menuExpediente: [
        {
          text: "Menu Expediente",
          description: "Controle completo de horários, turnos, escalas de trabalho e gestão de recursos humanos da produção.",
          icon: "mdi-clock-outline",
          color: "indigo-darken-1",
          routeMobile: "AberturaExpedienteMenuMobile",
          routeDesktop: "AberturaExpedienteMenuMobile",
          appPermission: "menu_expediente",
          adminOnly: false
        },
        {
          text: "Fechamento Outro Dia",
          description: "Fechamento de expediente para outro dia.",
          icon: "mdi-clock-outline",
          color: "indigo-darken-1",
          routeMobile: "FechamentoExpedienteOutroDiaMobile",
          routeDesktop: "FechamentoExpedienteOutroDiaDesktop",
          appPermission: "menu_fechamento_expediente_outro_dia",
          adminOnly: true
        },
        {
          text: "Alteração de Horários Manualmente",
          description: "Alteração de horários manualmente.",
          icon: "mdi-clock-outline",
          color: "indigo-darken-1",
          routeMobile: "ExpedienteAlteracaoHorarioManualMobile",
          routeDesktop: "ExpedienteAlteracaoHorarioManualDesktop",
          appPermission: "menu_alteracao_horarios_manual",
          adminOnly: true
        },
      ],

      menuSuporte: [
        {
          text: "Chamados",
          description: "Sistema de tickets para suporte técnico, solicitações de manutenção e resolução de problemas operacionais.",
          icon: "mdi-headset",
          color: "red-darken-1",
          routeMobile: "ConsultaChamadoMobile",
          routeDesktop: "ConsultaChamadoDesktop",
          appPermission: "menu_chamados",
          adminOnly: false
        },
      ],

      menuRelatorios: [
        {
          text: "Relatório de Horas Trabalhadas",
          description: "Visualize horas trabalhadas por ordem, agrupadas por data, com contagem de funcionários e totalizadores.",
          icon: "mdi-clock-time-four-outline",
          color: "blue-darken-1",
          routeMobile: "RelatorioHorasTrabalhadas",
          routeDesktop: "RelatorioHorasTrabalhadas",
          appPermission: "relatorio_horas_trabalhadas",
          adminOnly: false
        },
      ],

      menuSape: [
        {
          text: "Grupos De Produtos",
          description: "Consulta de grupos de produtos cadastrados no SAP.",
          icon: "mdi-shape-outline",
          color: "deep-orange-darken-1",
          appPermission: "menu_sape_grupos_produtos",
          routeMobile: "SapeConsultaProdutosGrupo",
          routeDesktop: "SapeConsultaProdutosGrupo",
          adminOnly: false
        },
          {
          text: "Depósitos",
          description: "Cadastro e consulta de depósitos (em desenvolvimento).",
          icon: "mdi-warehouse",
          color: "deep-orange-darken-1",
          appPermission: "menu_sape_depositos",
          routeMobile: "SapeConsultaDepositos",
          routeDesktop: "SapeConsultaDepositos",
          adminOnly: false
        },
        {
          text: "Produtos",
          description: "Consulta de produtos com filtros avançados e paginação.",
          icon: "mdi-package-variant",
          color: "deep-orange-darken-1",
          appPermission: "menu_sape_produtos",
          routeMobile: "SapeConsultaProdutos",
          routeDesktop: "SapeConsultaProdutos",
          adminOnly: false
        },
      
        {
          text: "Estoque Por Depósitos",
          description: "Consulta de produtos com estoque por depósito.",
          icon: "mdi-database-search",
          color: "deep-orange-darken-1",
          appPermission: "menu_sape_estoque_por_depositos",
          routeMobile: "SapeConsultaProdutosEstoques",
          routeDesktop: "SapeConsultaProdutosEstoques",
          adminOnly: false
        },
        {
          text: "Transferência de Estoque",
          description: "Gerenciar transferências de estoque entre depósitos.",
          icon: "mdi-swap-horizontal",
          color: "deep-orange-darken-2",
          appPermission: "menu_sape_transferencia_estoque",
          routeMobile: "SapeTransferenciaEstoque",
          routeDesktop: "SapeTransferenciaEstoque",
          adminOnly: false
        },
        {
          text: "SAP Entrada de Estoque",
          description: "Registrar entradas de mercadoria nos depósitos para integração com SAP.",
          icon: "mdi-package-down",
          color: "green-darken-2",
          appPermission: "menu_sap_movimentacao_estoque",
          routeMobile: "SapMovimentacaoEstoque",
          routeDesktop: "SapMovimentacaoEstoque",
          routeQuery: { tipo: 'ENTRADA' },
          adminOnly: false
        },
        {
          text: "SAP Saída de Estoque",
          description: "Registrar saídas de mercadoria dos depósitos para integração com SAP.",
          icon: "mdi-package-up",
          color: "red-darken-2",
          appPermission: "menu_sap_movimentacao_estoque",
          routeMobile: "SapMovimentacaoEstoque",
          routeDesktop: "SapMovimentacaoEstoque",
          routeQuery: { tipo: 'SAIDA' },
          adminOnly: false
        },
        {
          text: "Painel SAP Downloads",
          description: "Gerenciar downloads de planilhas Excel e confirmação de importação SAP.",
          icon: "mdi-download-box",
          color: "indigo-darken-2",
          appPermission: "menu_sap_downloads",
          routeMobile: "SapDownloads",
          routeDesktop: "SapDownloads",
          adminOnly: false
        },
      ],

      menuAdministracao: [
        {
          text: "Exclusão de Ordens",
          description: "Gerencie exclusões de ordens de produção com controle completo de auditoria e logs detalhados.",
          icon: "mdi-delete-outline",
          color: "red-darken-1",
          routeMobile: "AdministracaoExclusaoOrdens",
          routeDesktop: "AdministracaoExclusaoOrdens",
          appPermission: "menu_exclusao_ordens",
          adminOnly: true
        },
        {
          text: "Finalizar de Ordens",
          description: "Gerencie finalizações de ordens de produção .",
          icon: "mdi-delete-outline",
          color: "red-darken-1",
          routeMobile: "AdministracaoFinalizarOrdens",
          routeDesktop: "AdministracaoFinalizarOrdens",
          appPermission: "menu_finalizar_ordens",
          adminOnly: true
        },
        {
          text: "WhatsApp Config",
          description: "Configure mensagens automáticas, notificações e integração com WhatsApp para comunicação eficiente.",
          icon: "mdi-whatsapp",
          color: "green-darken-1",
          routeMobile: "WhatsAppConfigMobile",
          appPermission: "menu_whatsapp_config",
          routeDesktop: "WhatsAppConfigMobile",
          adminOnly: true
        },
      ],

      menuUsuarios: [
        {
          text: "Usuários Logados",
          description: "Monitore usuários conectados, gerencie sessões ativas e controle tokens de autenticação em tempo real.",
          icon: "mdi-account-multiple",
          color: "blue-darken-1",
          routeMobile: "AdministracaoUsuariosLogados",
          routeDesktop: "AdministracaoUsuariosLogados",
          appPermission: "menu_usuarios_logados",
          adminOnly: true
        },
        {
          text: "Gerenciar Usuários",
          description: "Crie e edite usuários, defina senhas, associe a múltiplos grupos e controle permissões de acesso ao sistema.",
          icon: "mdi-account-cog",
          color: "indigo-darken-1",
          routeMobile: "GerenciarUsuarios",
          routeDesktop: "GerenciarUsuarios",
          appPermission: "menu_gerenciar_usuarios",
          adminOnly: true
        },
        {
          text: "Gerenciar Grupos",
          description: "Organize usuários em grupos, defina hierarquias e configure conjuntos de permissões por departamento.",
          icon: "mdi-account-group",
          color: "deep-purple-darken-1",
          routeMobile: "GerenciarGrupos",
          routeDesktop: "GerenciarGrupos",
          appPermission: "menu_gerenciar_grupos",
          adminOnly: true
        },
        {
          text: "Gerenciar Permissões",
          description: "Configure permissões detalhadas por grupo e aplicação: acesso, inserção, edição, exclusão, exportação e impressão.",
          icon: "mdi-shield-lock",
          color: "pink-darken-1",
          routeMobile: "GerenciarPermissoes",
          routeDesktop: "GerenciarPermissoes",
          appPermission: "menu_gerenciar_permissoes",
          adminOnly: true
        },
        {
          text: "Gerenciar Aplicações",
          description: "Cadastre e gerencie aplicações do sistema. Ao criar, a aplicação será vinculada automaticamente a todos os grupos.",
          icon: "mdi-application-cog",
          color: "teal-darken-1",
          routeMobile: "GerenciarAplicacoes",
          routeDesktop: "GerenciarAplicacoes",
          appPermission: "menu_gerenciar_aplicacoes",
          adminOnly: true
        },
      ],

      // Constantes
      APP_VERSION,
      APP_DATE
    }
  },

  computed: {
    isMobile() {
      return window.innerWidth < 600;
    },

    nomeUsuario() {
      const userStore = this.$pinia?.state?.value?.user || {};
      return userStore.objetoUsuario?.name || "Usuário";
    },

    cargoUsuario() {
      const userStore = this.$pinia?.state?.value?.user || {};
      return userStore.objetoUsuario?.funcionario?.cargo?.nome || "Cargo não definido";
    },

    usuarioAdmin() {
      const userStore = this.$pinia?.state?.value?.user || {};
      if (userStore.objetoUsuario && userStore.objetoUsuario.priv_admin === 'Y') {
        return 'Administrador';
      }
      return 'Usuário Normal';
    },

    // ✅ VERIFICAR SE É ADMIN (boolean)
    isAdmin() {
      return this.usuarioAdmin === 'Administrador';
    },

    isAuthorizedUser() {
      const nome = this.nomeUsuario.toUpperCase();
      return nome === 'BRUNO TABOSA JODARC' || 
             nome === 'BRUNO TABOSA' || 
             nome === 'BRUNO TABOSA LOCALHOST';
    },

    // MENUS FILTRADOS POR ADMIN E PESQUISA
    // filterItems aplica AMBOS os filtros: permissão + pesquisa
    filteredMenuProducao() {
      return this.filterItems(this.menuProducao);
    },

    filteredMenuPlanejamento() {
      return this.filterItems(this.menuPlanejamento);
    },
    
    filteredMenuMaquinas() {
      return this.filterItems(this.menuMaquinas);
    },
    
    filteredMenuExpediente() {
      return this.filterItems(this.menuExpediente);
    },
    
    filteredMenuSuporte() {
      return this.filterItems(this.menuSuporte);
    },

    filteredMenuRelatorios() {
      try {
        const filtered = this.filterItems(this.menuRelatorios || []);
        // console.log('🔍 DEBUG RELATÓRIOS:', {
        //   menuOriginal: this.menuRelatorios,
        //   filtrado: filtered,
        //   temPermissao: this.hasAccess('relatorio_horas_trabalhadas'),
        //   usuario: this.userStore?.objetoUsuario?.login,
        //   permissions: this.userStore?.objetoUsuario?.permissions
        // });
        return filtered || [];
      } catch (error) {
        console.error('❌ Erro em filteredMenuRelatorios:', error);
        return [];
      }
    },

    filteredMenuSape() {
      return this.filterItems(this.menuSape);
    },

    filteredMenuAdministracao() {
      const menus = this.filterItems(this.menuAdministracao);
      
      // PROTEÇÃO: Gerenciar Aplicações só para tabosa
      return menus.filter(menu => {
        if (menu.text === 'Gerenciar Aplicações') {
          return this.userStore?.objetoUsuario?.login?.toLowerCase() === 'tabosa';
        }
        return true;
      });
    },

    filteredMenuUsuarios() {
      return this.filterItems(this.menuUsuarios);
    },

    // Contadores
    totalItens() {
      return this.menuProducao.length + this.menuPlanejamento.length + this.menuMaquinas.length + 
             this.menuExpediente.length + this.menuSuporte.length + this.menuRelatorios.length +
             this.menuSape.length + this.menuAdministracao.length + this.menuUsuarios.length;
    },

    totalItensVisiveis() {
      return this.filteredMenuProducao.length + 
      this.filteredMenuPlanejamento.length +
        this.filteredMenuMaquinas.length + 
        this.filteredMenuExpediente.length + 
        this.filteredMenuSuporte.length +
        this.filteredMenuRelatorios.length +
        this.filteredMenuSape.length +
        this.filteredMenuAdministracao.length +
        this.filteredMenuUsuarios.length;
    },

    gruposBuscaRapida() {
      return [
        { key: 'producao', titulo: 'PRODUÇÃO', icon: 'mdi-factory', color: 'amber-darken-2', itens: this.filterItemsByAdmin(this.menuProducao) },
        { key: 'planejamento', titulo: 'PLANEJAMENTO', icon: 'mdi-calendar-clock', color: 'purple-darken-2', itens: this.filterItemsByAdmin(this.menuPlanejamento) },
        { key: 'maquinas', titulo: 'MÁQUINAS', icon: 'mdi-cog', color: 'blue-darken-2', itens: this.filterItemsByAdmin(this.menuMaquinas) },
        { key: 'expediente', titulo: 'EXPEDIENTE', icon: 'mdi-clock-outline', color: 'indigo-darken-2', itens: this.filterItemsByAdmin(this.menuExpediente) },
        { key: 'suporte', titulo: 'SUPORTE', icon: 'mdi-headset', color: 'green-darken-2', itens: this.filterItemsByAdmin(this.menuSuporte) },
        { key: 'relatorios', titulo: 'RELATÓRIOS', icon: 'mdi-file-chart', color: 'cyan-darken-2', itens: this.filterItemsByAdmin(this.menuRelatorios) },
        { key: 'sape', titulo: 'SAP', icon: 'mdi-database', color: 'deep-orange-darken-2', itens: this.filterItemsByAdmin(this.menuSape) },
        { key: 'administracao', titulo: 'ADMINISTRAÇÃO', icon: 'mdi-shield-crown', color: 'red-darken-2', itens: this.filterItemsByAdmin(this.menuAdministracao) },
        { key: 'usuarios', titulo: 'USUÁRIOS', icon: 'mdi-account-cog', color: 'blue-grey-darken-2', itens: this.filterItemsByAdmin(this.menuUsuarios) },
      ];
    },

    resultadosBuscaRapida() {
      const termo = this.buscaRapidaTermo?.trim();
      if (!termo) return [];

      return this.gruposBuscaRapida
        .map(grupo => {
          const itens = (grupo.itens || []).filter(item => {
            const base = `${item.text || ''} ${item.description || ''}`;
            return this.smartSearch(base, termo);
          });
          return { ...grupo, itens };
        })
        .filter(grupo => grupo.itens.length > 0);
    },

    totalResultadosBuscaRapida() {
      return this.resultadosBuscaRapida.reduce((acc, grupo) => acc + grupo.itens.length, 0);
    },

    allExpanded() {
      return Object.values(this.expandedSections).every(section => section);
    }
  },

  methods: {
    // ========================================
    // ✅ MÉTODO PARA FILTRAR POR ADMIN E PERMISSÕES
    // ========================================
    
    filterItemsByAdmin(items) {
      return items.filter(item => {
        // 1. Verificar permissão de ACESSO (se definida)
        if (item.appPermission) {
          // Verifica se usuário tem ACESSO (priv_access = Y) à aplicação
          if (!this.hasAccess(item.appPermission)) {
            return false; // Sem acesso, não mostra
          }
        }
        
        // 2. Verificar adminOnly (legacy)
        // Se não tem adminOnly definido, mostra
        if (item.adminOnly === undefined) {
          return true;
        }
        
        // Se adminOnly é false, mostra
        if (!item.adminOnly) {
          return true;
        }
        
        // Se adminOnly é true, só mostra se for admin
        return this.isAdmin;
      });
    },

    // ========================================
    // ✅ MÉTODOS DE ROTA MELHORADOS
    // ========================================

    getRouteInfo(routeName) {
      // Buscar informações da rota em todos os menus
      const allMenus = [
        ...this.menuProducao,
        ...this.menuPlanejamento,
        ...this.menuMaquinas,
        ...this.menuExpediente,
        ...this.menuSuporte,
        ...this.menuRelatorios,
        ...this.menuSape,
        ...this.menuAdministracao,
        ...this.menuUsuarios
      ];

      const routeItem = allMenus.find(item => 
        item.routeMobile === routeName || item.routeDesktop === routeName
      );

      if (routeItem) {
        return {
          name: routeItem.text,
          icon: routeItem.icon,
          color: routeItem.color
        };
      }

      // Fallback para rotas não encontradas
      return {
        name: "Página",
        icon: "mdi-file-document",
        color: "grey-darken-2"
      };
    },

    // ========================================
    // MÉTODOS PRINCIPAIS
    // ========================================

// ✅ CORRETO - faz logout real
async logout() {
  try {
    // Usa o userStore que foi injetado pelo setup()
    await this.userStore.logout();
    this.$router.push({ name: "Login" });
  } catch (error) {
    console.error('Erro ao fazer logout:', error);
    // Fazer fallback para rota de login mesmo em caso de erro
    this.$router.push({ name: "Login" });
  }
},

    // ========================================
    // 🏠 NAVEGAR PARA HOME
    // ========================================
    goToHome() {
      // Fechar o menu lateral
      this.drawer = false;
      
      // Navegar para a tela inicial
      if (this.$route.name !== 'MenuDefault') {
        this.$router.push({ name: 'MenuDefault' });
        console.log('🏠 Navegando para tela inicial');
      }
    },

    async navigateTo(routeMobile, routeDesktop, routeText, routeQuery = null) {
      try {
        const route = this.isMobile ? routeMobile : routeDesktop;
        const routeInfo = this.getRouteInfo(route);

        // Montar objeto de rota
        const routeObj = { name: route };
        if (routeQuery) {
          routeObj.query = routeQuery;
        }

        // Verificar se já está na mesma rota (evitar navegação duplicada)
        const currentRoute = this.$route;
        const isSameRoute = currentRoute.name === route &&
          JSON.stringify(currentRoute.query || {}) === JSON.stringify(routeQuery || {});

        if (isSameRoute) {
          this.drawer = false;
          return;
        }

        // Fechar o menu lateral e mostrar loading
        this.drawer = false;
        this.currentRouteName = routeText || routeInfo.name;
        this.routeIcon = routeInfo.icon;
        this.routeIconColor = routeInfo.color;
        this.loadingMessage = "Carregando...";
        this.loadingRouteDialog = true;

        // Navegar imediatamente para a rota
        await this.$router.push(routeObj);

      } catch (error) {
        // Ignorar erros de navegação duplicada (NavigationDuplicated)
        if (error.name !== 'NavigationDuplicated' && !error.message?.includes('Avoided redundant navigation')) {
          console.error("Erro no redirecionamento:", error.message);
        }
      } finally {
        // Ocultar diálogo de carregamento
        this.loadingRouteDialog = false;

        // Reset das informações
        setTimeout(() => {
          this.currentRouteName = "";
          this.routeIcon = "mdi-loading";
          this.routeIconColor = "grey-darken-2";
          this.loadingMessage = "Preparando interface...";
        }, 300);
      }
    },

    onChangelogUpdated(newChangelog) {
      console.log('Changelog atualizado:', newChangelog);
    },

    // ========================================
    // MÉTODOS DE CONTROLE DE INTERFACE
    // ========================================

    setHoveredItem(item) {
      if (this.historyEnabled) {
        this.hoveredItem = item;
      }
    },

    clearHoveredItem() {
      if (this.historyEnabled) {
        this.hoveredItem = null;
      }
    },

    abrirBuscaRapida() {
      this.dialogBuscaRapida = true;
      this.buscaRapidaTermo = '';
      this.$nextTick(() => {
        this.$refs.buscaRapidaInput?.focus?.();
      });
    },

    fecharBuscaRapida() {
      this.dialogBuscaRapida = false;
      this.buscaRapidaTermo = '';
    },

    navegarBuscaRapida(item) {
      this.fecharBuscaRapida();
      this.navigateTo(item.routeMobile, item.routeDesktop, item.text, item.routeQuery || null);
    },

    highlightBuscaRapida(text) {
      if (!this.buscaRapidaTermo) return text;
      try {
        const termo = this.buscaRapidaTermo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${termo})`, 'gi');
        return text.replace(regex, '<span class="highlight-search">$1</span>');
      } catch (error) {
        return text;
      }
    },

    handleAtalhoBusca(event) {
      const targetTag = event.target?.tagName?.toLowerCase();
      const isTypingContext = ['input', 'textarea', 'select'].includes(targetTag) || event.target?.isContentEditable;
      const key = event.key?.toLowerCase();

      if ((event.ctrlKey || event.metaKey) && key === 'k') {
        event.preventDefault();
        this.abrirBuscaRapida();
        return;
      }

      if (event.key === 'Escape' && this.dialogBuscaRapida) {
        event.preventDefault();
        this.fecharBuscaRapida();
        return;
      }

      if (isTypingContext) return;
    },

    // ========================================
    // MÉTODOS DE PESQUISA E FILTRO
    // ========================================

    removeAccents(str) {
      if (!str) return '';
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },

    smartSearch(text, query) {
      if (!query || !text) return true;
      
      const normalizedText = this.removeAccents(text);
      const normalizedQuery = this.removeAccents(query);
      
      // Busca simples
      if (normalizedText.includes(normalizedQuery)) {
        return true;
      }
      
      // Busca por palavras separadas
      const queryWords = normalizedQuery.split(/\s+/).filter(word => word.length > 0);
      return queryWords.every(queryWord => normalizedText.includes(queryWord));
    },

    filterItems(items) {
      // ✅ PRIMEIRO FILTRA POR ADMIN, DEPOIS POR PESQUISA
      const itemsWithPermission = this.filterItemsByAdmin(items);
      
      // Se pesquisa desabilitada, retorna os itens com permissão
      if (!this.searchEnabled) {
        return itemsWithPermission;
      }
      
      // Se não há query, retorna os itens com permissão
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        return itemsWithPermission;
      }
      
      const query = this.searchQuery.trim();
      return itemsWithPermission.filter(item => this.smartSearch(item.text, query));
    },

    highlightSearch(text) {
      if (!this.searchEnabled || !this.searchQuery) return text;
      
      const query = this.searchQuery.trim();
      if (!query) return text;
      
      try {
        const normalizedQuery = this.removeAccents(query);
        const words = normalizedQuery.split(/\s+/).filter(w => w.length > 0);
        
        let result = text;
        words.forEach(word => {
          const pattern = word.split('').map(char => {
            const accents = {
              'a': '[aáàâãäå]', 'e': '[eéèêë]', 'i': '[iíìîï]',
              'o': '[oóòôõö]', 'u': '[uúùûü]', 'c': '[cç]', 'n': '[nñ]'
            };
            return accents[char] || char;
          }).join('');
          
          const regex = new RegExp(`(${pattern})`, 'gi');
          result = result.replace(regex, '<mark class="highlight-search">$1</mark>');
        });
        
        return result;
      } catch (error) {
        console.error('Erro no highlight:', error);
        return text;
      }
    },

    onSearch() {
      if (this.searchEnabled && this.searchQuery && this.searchQuery.trim()) {
        // ✅ EXPANDIR APENAS SEÇÕES COM RESULTADOS, FECHAR AS DEMAIS
        this.expandedSections.producao = this.filteredMenuProducao.length > 0;
        this.expandedSections.planejamento = this.filteredMenuPlanejamento.length > 0;
        this.expandedSections.maquinas = this.filteredMenuMaquinas.length > 0;
        this.expandedSections.expediente = this.filteredMenuExpediente.length > 0;
        this.expandedSections.suporte = this.filteredMenuSuporte.length > 0;
        this.expandedSections.relatorios = this.filteredMenuRelatorios.length > 0;
        this.expandedSections.sape = this.filteredMenuSape.length > 0;
        this.expandedSections.administracao = this.filteredMenuAdministracao.length > 0;
        this.expandedSections.usuarios = this.filteredMenuUsuarios.length > 0;
      } else {
        // ✅ QUANDO LIMPAR A PESQUISA, FECHAR TODAS AS SEÇÕES
        this.expandedSections.producao = false;
        this.expandedSections.planejamento = false;
        this.expandedSections.maquinas = false;
        this.expandedSections.expediente = false;
        this.expandedSections.suporte = false;
        this.expandedSections.relatorios = false;
        this.expandedSections.sape = false;
        this.expandedSections.administracao = false;
        this.expandedSections.usuarios = false;
      }
    },

    showDevelopmentAlert(menuItemName) {
      alert(`${menuItemName} está em desenvolvimento.`);
    },

    handleSapeClick(item) {
      if (item?.routeMobile || item?.routeDesktop) {
        return this.navigateTo(item.routeMobile, item.routeDesktop, item.text, item.routeQuery || null);
      }
      return this.showDevelopmentAlert(item.text);
    },

    // ========================================
    // MÉTODOS DE NAVEGAÇÃO E SEÇÕES
    // ========================================

    toggleSection(section) {
      this.expandedSections[section] = !this.expandedSections[section];
    },

    toggleAllSections() {
      const newState = !this.allExpanded;
      this.expandedSections.producao = newState;
      this.expandedSections.planejamento = newState;
      this.expandedSections.maquinas = newState;
      this.expandedSections.expediente = newState;
      this.expandedSections.suporte = newState;
      this.expandedSections.relatorios = newState;
      this.expandedSections.sape = newState;
      this.expandedSections.administracao = newState;
      this.expandedSections.usuarios = newState;
    }
  },

  mounted() {
    window.addEventListener('keydown', this.handleAtalhoBusca);
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleAtalhoBusca);
  }
};
</script>
<style scoped>
/* ✅ ESTILOS DO MODAL DE CARREGAMENTO DE ROTA */
.route-loading-overlay {
  backdrop-filter: blur(2px);
}

.route-loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.route-loading-card {
  background: rgba(250, 250, 250, 0.95) !important;
  border-radius: 20px !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  max-width: 320px;
  width: 100%;
}

.route-icon-container {
  position: relative;
  display: inline-block;
}

.route-avatar {
  background: rgba(245, 245, 245, 0.8) !important;
  border: 2px solid rgba(0, 0, 0, 0.05);
}

.loading-spinner-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.loading-spinner {
  opacity: 0.8;
}

.route-loading-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.5px;
}

.route-loading-subtitle {
  font-size: 0.875rem;
  color: #666;
  font-weight: 400;
}

.progress-container {
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
}

.route-progress {
  opacity: 0.7;
}

/* ✅ ANIMAÇÃO SUAVE PARA O MODAL */
.route-loading-card {
  animation: routeLoadingFadeIn 0.3s ease-out;
}

@keyframes routeLoadingFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ✅ ANIMAÇÃO DO ÍCONE */
.route-avatar {
  animation: routeIconPulse 2s ease-in-out infinite;
}

@keyframes routeIconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* ✅ LAYOUT CORRIGIDO - REMOVENDO CONFLITOS DE POSIÇÃO */

/* Header - usando app ao invés de fixed */
.app-bar-gradient {
  background: linear-gradient(135deg, #1976d2 0%, #1e88e5 50%, #2196f3 100%) !important;
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.3) !important;
}

/* ✅ CONTEÚDO PRINCIPAL - PERMITINDO SCROLL NATURAL */
.main-content {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  min-height: 100vh;
  /* REMOVIDO: padding-top, padding-bottom, height fixas */
  /* REMOVIDO: overflow controls que impediam scroll */
}

 

/* ✅ PERMITIR SCROLL NATURAL NO MAIN WRAP */
/* REMOVIDO: .main-content .v-main__wrap com height e overflow fixos */

/* Footer - mantendo app ao invés de fixed */
.footer-modern {
  background: linear-gradient(135deg, #263238 0%, #37474f 100%);
  color: white;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* ✅ ESTILOS DO HEADER MANTIDOS */
.nav-icon {
  transition: all 0.3s ease;
}

.nav-icon:hover {
  transform: rotate(90deg);
}

.logo-avatar {
  background: linear-gradient(135deg, #ffffff20, #ffffff40);
  backdrop-filter: blur(10px);
}

/* ✅ LOGO CLICÁVEL COM HOVER */
.logo-clickable {
  transition: all 0.3s ease;
  border-radius: 12px;
  padding: 6px 12px;
  margin-left: -12px;
}

.logo-clickable:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-1px);
}

.logo-clickable:hover .logo-avatar {
  transform: scale(1.1);
}

.logo-clickable:active {
  transform: translateY(0);
}

.app-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: white !important;
  letter-spacing: 1px;
}

.app-subtitle {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  margin-top: -4px;
}

.user-menu-btn {
  color: white !important;
  transition: all 0.3s ease;
  border-radius: 12px !important;
  padding: 8px 12px !important;
}

.user-menu-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-1px);
}

.user-avatar {
  background: linear-gradient(135deg, #ffffff30, #ffffff50);
  backdrop-filter: blur(10px);
}

.user-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
}

.user-role {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
}

.topbar-search-btn {
  color: #0d47a1 !important;
  background: rgba(255, 255, 255, 0.92) !important;
  border: 1px solid rgba(255, 255, 255, 0.55) !important;
  transition: all 0.2s ease !important;
}

.topbar-search-btn:hover {
  color: #0b3f95 !important;
  background: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(10, 67, 160, 0.22) !important;
}

.topbar-search-icon {
  color: #0d47a1 !important;
}

.toolbar-divider {
  height: 24px;
  border-color: rgba(255, 255, 255, 0.35) !important;
}

.busca-rapida-card {
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.busca-rapida-results {
  max-height: calc(82vh - 210px);
  overflow-y: auto;
}

.busca-rapida-card-item {
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.02) !important;
}

.busca-rapida-card-item:hover {
  background: rgba(25, 118, 210, 0.06) !important;
  border-color: rgba(25, 118, 210, 0.25) !important;
  transform: translateY(-1px);
}

.busca-rapida-card-item:hover .chevron-action {
  opacity: 1 !important;
  color: #1976d2;
  transform: translateX(2px);
}

.search-input-premium :deep(.v-field) {
  background: rgba(0, 0, 0, 0.03) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.user-menu-card {
  border-radius: 16px !important;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.user-menu-header {
  background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%);
}

.menu-list-item {
  margin-bottom: 4px;
  transition: all 0.2s ease;
}

.menu-list-item:hover {
  background-color: rgba(25, 118, 210, 0.08);
  transform: translateX(4px);
}

.logout-item:hover {
  background-color: rgba(244, 67, 54, 0.08) !important;
}

/* ✅ NAVIGATION DRAWER - CORRIGIDO */
.navigation-drawer {
  border-right: 1px solid rgba(0, 0, 0, 0.06) !important;
  display: flex;
  flex-direction: column;
}

.drawer-header-advanced {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.control-btn {
  transition: all 0.3s ease;
  border-radius: 6px !important;
}

.control-btn:hover {
  background-color: rgba(25, 118, 210, 0.1) !important;
  transform: scale(1.1);
}

.search-field {
  border-radius: 8px;
}

.search-field .v-field {
  border-radius: 8px !important;
}

.highlight-search {
  background-color: #ffeb3b;
  color: #333;
  padding: 1px 2px;
  border-radius: 2px;
  font-weight: bold;
}

/* ✅ MENU CONTAINER - ALTURA DINÂMICA CORRIGIDA */
.menu-main-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 180px); /* Altura base mais flexível */
}

.menu-main-container.with-search {
  height: calc(100vh - 220px);
}

.menu-main-container.with-search.with-history {
  height: calc(100vh - 260px);
}

.menu-content-scrollable {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 8px;
}

.logout-section-minimal {
  position: sticky;
  bottom: 0;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  z-index: 5;
}

.logout-btn-minimal {
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 36px !important;
  box-shadow: 0 2px 6px rgba(244, 67, 54, 0.25) !important;
  transition: all 0.3s ease !important;
}

.logout-btn-minimal:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 3px 8px rgba(244, 67, 54, 0.35) !important;
}

.menu-section {
  margin-bottom: 8px;
}

.section-header {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.04));
  border-radius: 8px;
  margin: 8px 0;
  border-left: 4px solid;
  cursor: pointer;
  transition: all 0.3s ease;
}

.section-header:hover {
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.06));
  transform: translateX(2px);
}

.section-toggle-icon {
  transition: transform 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

.menu-item-modern {
  transition: all 0.3s ease;
  margin: 2px 0;
  border-radius: 12px;
  padding: 8px 12px !important;
  min-height: 56px;
}

.menu-item-modern:hover {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.08), rgba(25, 118, 210, 0.12));
  transform: translateX(8px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.menu-title-complete {
  font-size: 0.95rem !important;
  line-height: 1.3 !important;
  font-weight: 700 !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: initial !important;
  word-wrap: break-word;
  hyphens: auto;
}

/* ✅ ANIMAÇÕES MANTIDAS */
@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.menu-section {
  animation: slideInFromLeft 0.4s ease;
}

.menu-section:nth-child(2) {
  animation-delay: 0.1s;
}

.menu-section:nth-child(3) {
  animation-delay: 0.2s;
}

.menu-section:nth-child(4) {
  animation-delay: 0.3s;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.controls-bar {
  animation: fadeInDown 0.3s ease;
}

/* ✅ RESPONSIVIDADE CORRIGIDA */
@media (max-width: 768px) {
  .app-title {
    font-size: 1.25rem !important;
  }
  
  .app-subtitle {
    display: none;
  }
  
  .user-name, .user-role {
    display: none;
  }

  .section-header {
    padding: 12px 16px;
  }

  .menu-item-modern {
    min-height: 48px;
    padding: 6px 10px !important;
  }

  .menu-title-complete {
    font-size: 0.875rem !important;
  }

  /* ✅ ALTURAS MOBILE CORRIGIDAS */
  .menu-main-container {
    height: calc(100vh - 160px);
  }

  .menu-main-container.with-search {
    height: calc(100vh - 200px);
  }

  .menu-main-container.with-search.with-history {
    height: calc(100vh - 240px);
  }

  .logout-btn-minimal {
    height: 32px !important;
    font-size: 0.75rem !important;
  }

  .control-btn {
    min-width: 32px !important;
    height: 32px !important;
  }

  /* ✅ AJUSTES MOBILE PARA O MODAL */
  .route-loading-card {
    max-width: 280px;
    margin: 16px;
  }

  .route-loading-title {
    font-size: 1rem;
  }

  .route-loading-subtitle {
    font-size: 0.8rem;
  }

  .route-avatar {
    width: 56px !important;
    height: 56px !important;
  }

  .loading-spinner {
    width: 64px !important;
    height: 64px !important;
  }
}

/* ✅ SCROLLBAR CUSTOMIZADA MANTIDA */
.menu-content-scrollable::-webkit-scrollbar {
  width: 6px;
}

.menu-content-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.menu-content-scrollable::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #1976d2, #2196f3);
  border-radius: 3px;
}

.menu-content-scrollable::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #1565c0, #1976d2);
}

.flex-grow-1 {
  min-width: 0;
}

/* ✅ ANIMAÇÕES FINAIS MANTIDAS */
@keyframes slideUpFromBottom {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.logout-section-minimal {
  animation: slideUpFromBottom 0.5s ease;
}

.logout-section-minimal::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #f44336, #d32f2f);
  border-radius: 1px 1px 0 0;
  opacity: 0.5;
}

.menu-main-container {
  transition: height 0.3s ease;
}

.control-btn[color="success"],
.control-btn[color="info"] {
  background-color: rgba(var(--v-theme-success), 0.1) !important;
}

.control-btn[color="grey"] {
  opacity: 0.6;
}

/* ✅ EFEITOS ESPECIAIS PARA O MODAL MANTIDOS */
.route-loading-overlay :deep(.v-overlay__scrim) {
  background: rgba(240, 240, 240, 0.4) !important;
}

.route-progress :deep(.v-progress-linear__determinate) {
  animation: progressShimmer 1.5s ease-in-out infinite;
}

@keyframes progressShimmer {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

.route-loading-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  border-radius: 20px;
  pointer-events: none;
}

.route-avatar {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.route-avatar .v-icon {
  transition: color 0.3s ease;
}
</style>
